const style = {
  display: "flex",
  flexDirection: "column",
  gap: 6
};

export function SettingContainer(props) {
  return (<>
    <div style={ style }>{ props.children }</div>
  </>);
}
